import { render, staticRenderFns } from "./allList.vue?vue&type=template&id=26c26a35"
import script from "./allList.vue?vue&type=script&lang=js"
export * from "./allList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26c26a35')) {
      api.createRecord('26c26a35', component.options)
    } else {
      api.reload('26c26a35', component.options)
    }
    module.hot.accept("./allList.vue?vue&type=template&id=26c26a35", function () {
      api.rerender('26c26a35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/reviewManage/allList.vue"
export default component.exports